import { render, staticRenderFns } from "./LiveTicker.vue?vue&type=template&id=1380df05&"
import script from "./LiveTicker.vue?vue&type=script&lang=js&"
export * from "./LiveTicker.vue?vue&type=script&lang=js&"
import style0 from "./LiveTicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports